import React from 'react';
import { createPortal } from 'react-dom';
import StorageBoxFileAudioSession from './StorageBoxFileAudioSession';
import { useGlobalStorageBoxAudio } from './globalStorageBoxAudioSession';
import '../../../storageBox/StorageBoxPage.css';

/**
 * Single app-wide Storage Box audio session (playback survives route changes).
 */
export default function GlobalStorageBoxAudioHost() {
  const {
    isActive,
    fileItem,
    initialPlaylist,
    publicToken,
    theme,
    minimized,
    setMinimized,
    inlineHostEl,
    sessionApiRef,
    playFileNow,
    closeSession,
  } = useGlobalStorageBoxAudio();

  if (typeof document === 'undefined') {
    return null;
  }

  // Inline host: full studio (including browse) even before the first track plays.
  if (!inlineHostEl && !isActive) {
    return null;
  }

  const presentation = inlineHostEl ? 'inline' : 'modal';

  const session = (
    <StorageBoxFileAudioSession
      fileItem={fileItem}
      theme={theme}
      initialPlaylist={initialPlaylist}
      publicToken={publicToken}
      presentation={presentation}
      minimized={minimized}
      onMinimizedChange={setMinimized}
      sessionApiRef={sessionApiRef}
      onFileSelected={playFileNow}
      onSessionClose={closeSession}
    />
  );

  if (inlineHostEl) {
    return createPortal(session, inlineHostEl);
  }

  return session;
}
